<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                    <wbo-textarea-edit-control formControlName="companyName" [(ngModel)]="model.data.companyName">
                    </wbo-textarea-edit-control>
            </fui-column>
            <fui-column>
                <fui-tandem-field>
                    <wbo-text-edit-control formControlName="ABN" [(ngModel)]="model.data.ABN"></wbo-text-edit-control>
                    <wbo-text-edit-control formControlName="gstNumber" [(ngModel)]="model.data.gstNumber"></wbo-text-edit-control>
                </fui-tandem-field>
                <wbo-currency-type-single-select-edit-control formControlName="currency" [(ngModel)]="model.data.currency">
                </wbo-currency-type-single-select-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column [label]="'wbo.company-details.edit.label.postal-address'">
                <fui-tandem-field formGroupName="address">
                <wbo-text-edit-control formControlName="street" [(ngModel)]="model.data.address.street"
                                       [label]="'wbo.address.edit.field.street.label'"
                                       [placeholder]="'wbo.address.edit.field.street.placeholder'"></wbo-text-edit-control>
                <wbo-text-edit-control formControlName="city" [(ngModel)]="model.data.address.city"
                                       [label]="'wbo.address.edit.field.city.label'"
                                       [placeholder]="'wbo.address.edit.field.city.placeholder'"></wbo-text-edit-control>
                </fui-tandem-field>
                <fui-tandem-field formGroupName="address">
                    <wbo-text-edit-control formControlName="state" [(ngModel)]="model.data.address.state"
                                           [label]="'wbo.address.edit.field.state.label'"
                                           [placeholder]="'wbo.address.edit.field.state.placeholder'"></wbo-text-edit-control>
                    <wbo-text-edit-control formControlName="postCode" [(ngModel)]="model.data.address.postCode"
                                           [label]="'wbo.address.edit.field.postCode.label'"
                                           [placeholder]="'wbo.address.edit.field.postCode.placeholder'"></wbo-text-edit-control>

                </fui-tandem-field>
                <fui-tandem-field formGroupName="address">
                    <wbo-text-edit-control formControlName="country" [(ngModel)]="model.data.address.country"
                                           [label]="'wbo.address.edit.field.country.label'"
                                           [placeholder]="'wbo.address.edit.field.country.placeholder'"></wbo-text-edit-control>
                </fui-tandem-field>
            </fui-column>
            <fui-column>
                <wbo-text-edit-control formControlName="telephone" [(ngModel)]="model.data.telephone"></wbo-text-edit-control>
                <wbo-text-edit-control formControlName="email" [(ngModel)]="model.data.email"></wbo-text-edit-control>
                <ng-container formGroupName="logoImageData">
                    <wbo-image-edit-control formControlName="image" [(ngModel)]="model.data.logoImageData.image">
                    </wbo-image-edit-control>
                </ng-container>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
